import React, {useEffect} from "react";

const InputSwitch = props => {
    const { attribute, returnType, label, marginTop, marginBottom, classname, value, readonly, handleChange } = props;

    const changeEvent = checked => {
        if (readonly !== undefined && readonly !== null && readonly)
            return;

        if (handleChange === null)
            return;

        handleChange(attribute, returnType, checked ? 1 : 0);
    }

    return (
        <div className={ "inputSwitch" + (classname !== undefined ? " " + classname : "") + (marginTop !== undefined ? " marginTop" : "") + (marginBottom !== undefined ? " marginBottom" : "") }>
            <span>{label}</span>
            <div className={"containerSwitch"}>
                <p className={"switch no" + (value === 0 ? " selected" : "")} onClick={() => { changeEvent(false); }}>Non</p>
                <p className={"switch margin yes" + (value === 1 ? " selected" : "")} onClick={() => { changeEvent(true); }}>Oui</p>
            </div>
        </div>
    );
}

export default InputSwitch;
